/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import {inject} from '@angular/core';
import {Observable, catchError, finalize, of, switchMap, throwError} from 'rxjs';

import {LoginService} from 'src/app/feature/dealer/login/service/login.service';
import {AppPrincipalService} from 'src/app/shared/service/principal/app-principal.service';
import {AppStorageService} from 'src/app/shared/service/storage/app-storage.service';
import AppConstant from '../../shared/constants/app.constant';
import {LoaderService} from 'src/app/shared/service/loader/loader.service';
import {ApiEnum} from 'src/app/shared/constants/api.enum';
import {ToastService} from 'src/app/shared/service/toast/toast.service';
import appUtil from 'src/app/shared/util/app.util';

const isUrlNotExcluded = (req: HttpRequest<any>) => {
  if (
    req.url?.includes(ApiEnum.LOGIN_BASE_URL) ||
    req.url?.includes(ApiEnum.CUSTOMER_BASE_URL) ||
    req.url.includes(ApiEnum.CUSTOMER_V2_BASE_URL)
  ) {
    return false;
  }
  return true;
};
let count = 0;
export const httpInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  // Block OPTIONS preflight requests as per VAPT guidelines
  if (req.method === 'OPTIONS') {
    return of(new HttpResponse({status: 200, body: {}}));
  }
  const principalService = inject(AppPrincipalService);
  const loginService = inject(LoginService);
  const storageService = inject(AppStorageService);
  const loadingService = inject(LoaderService);
  const toast = inject(ToastService);
  if (count === 0) {
    loadingService.setLoading(true);
  }
  if (isUrlNotExcluded(req)) {
    req = addToken(principalService, req);
  }
  count++;
  return next(req).pipe(
    switchMap((resp: any) => {
      if (resp instanceof HttpResponse) {
        const {body} = resp;
        if (body?.data) {
          const {data} = body;
          if (data?.responseCode === 401 && data?.responseMessage?.includes('Access token')) {
            const refreshToken = getRefToken(principalService);
            if (req.url === `${ApiEnum.LOGIN_BASE_URL}/refresh` || appUtil.isEmpty(refreshToken)) {
              if (principalService.isDealer()) {
                void loginService.logOut(true);
              }
              return throwError(() => new Error('Failed to refresh token'));
            }
            return loginService.getToken(refreshToken).pipe(
              switchMap((refResp: {data: {data: Record<string, any>}}) => {
                const token = refResp?.data?.data['x-access-token'];
                storageService.setItem(AppConstant.STORAGE_KEYS.SIT_T, token);
                const reqClone = req.clone({
                  setHeaders: {
                    'x-access-token': token,
                  },
                });
                // Return the cloned request
                return next(reqClone);
              }),
              catchError(async error => {
                console.error('Error occurred during token refresh:', error);
                if (principalService.isDealer()) {
                  await loginService.logOut(true);
                }
                return throwError(() => new Error('Failed to refresh token'));
              })
            );
          }
          // Show error message for rate limiting
          if (data?.responseCode === 429) {
            void toast.show({
              message: data.responseMessage,
              color: 'danger',
            });
            return next(req);
          }
        }
      }
      return of(resp);
    }),
    finalize(() => {
      count--;
      if (count === 0) {
        loadingService.setLoading(false);
      }
    })
  );
};
function addToken(principalService: AppPrincipalService, req: HttpRequest<any>): HttpRequest<any> {
  const token = getToken(principalService);
  const cloned = req.clone({
    setHeaders: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'x-access-token': token,
    },
  });
  return cloned;
}

function getToken(principalService: AppPrincipalService): string {
  return principalService.isDealer()
    ? principalService.getToken()
    : principalService.getCustomerToken();
}

function getRefToken(principalService: AppPrincipalService): string {
  return principalService.getRefToken();
}
